import styled from "styled-components"

export const Card = styled.div`
  display: flex;
  width: 416px;
  height: 208px;
  padding: 16px;
  justify-content: center;
  align-items: center;

  border-radius: 16px;
  border: 1px solid var(--base-gray40, #bfbfbf);
  background: var(--base-white100, #fff);
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 24px 32px;
  flex: 1 0 0;
  flex-wrap: wrap;
`

export const Frame = styled.div`
  display: flex;
  width: 152px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`

export const Title = styled.div`
  display: flex;
  padding: 4px 0px;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  border-radius: 4px;
  background: var(--secondary20, #e3e9f7);

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const CardItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
`

export const MainContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 4px;
  align-self: stretch;
`

export const MainValue = styled.div`
  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const MainUnit = styled.div`
  color: var(--base-gray60, #8c8c8c);
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const SubContent = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2px;
`

export const SubContent1 = styled.div`
  color: var(--base-gray90, #404040);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const SubContent2 = styled.div<{ increase: boolean }>`
  color: ${(props) => (props.increase ? "#c74646" : "#11ab68")};
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const SubContent3 = styled.div<{ increase: boolean }>`
  color: ${(props) => (props.increase ? "#c74646" : "#11ab68")};
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`
